import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { showSweetAlert } from '../components/SweetAlert';

const getApiBaseUrl = (domain) => `https://${domain}.nodoji.com`;
// const getApiBaseUrl = (domain) => `https://userapi.nodojicommodities.com`;

// Send cookies when calling user subdomain so IBKR gateway session is sent and Flask can forward it
axios.interceptors.request.use((config) => {
    if (config.url && config.url.includes('.nodoji.com') && config.url.includes('/custom-apis')) {
        config.withCredentials = true;
    }
    return config;
});

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [auth, setAuth] = useState({
        accessToken: localStorage.getItem('accessToken') || null,
        refreshToken: localStorage.getItem('refreshToken') || null,
        userId: localStorage.getItem('userId') || null,
    });
    const [thirdParyAccount, setThirdParyAccount] = useState('');
    const [apiProvider, setApiProvider] = useState('polygon');
    const [userData, setUserData] = useState(null);
    // const [selectedValue, setSelectedValue] = useState('AAPL');
    const [selectedValue, setSelectedValue] = useState(() => {
        return localStorage.getItem('chartSymbol') || "AAPL";
    });
    const [selectedValueAnalysis, setSelectedValueAnalysis] = useState([]);
    // const [symbolData, setSymbolData] = useState('AAPL');
    const [symbolData, setSymbolData] = useState(() => {
        return localStorage.getItem('chartSymbol') || "AAPL";
    });
    const [baseCurencySymbol, setBaseCurencySymbol] = useState();
    const [curencySymbol, setCurencySymbol] = useState();
    const [openSettings, setOpenSettings] = useState(false);
    const [currentDate, setCurrentDate] = useState('');
    const [currentTime, setCurrentTime] = useState('');
    const [symbolTradeDate, setSymbolTradeDate] = useState(null);
    const handleOpenSettings = () => setOpenSettings(true);
    const handleCloseSettings = () => setOpenSettings(false);
    const handleOpenEtradeAuth = () => setShowEtradeAuth(true);
    const handleCloseEtradeAuth = () => setShowEtradeAuth(false);
    const [tradeData, setTradeData] = useState([]);
    const [recentTransactionsData, setRecentTransactionsData] = useState([]);
    const settingParams = {}; 
    const integrationsParams = {}; 
    const [accountInfoData, setaccountInfoData] = useState({});
    const [watchlistData, setWatchlistData] = useState();
    const [perfomanceChartData, setPerfomanceChartData] = useState([]);
    const [yourHoldingData, setYourHoldingData] = useState([]);
    const [preferenceData, setPreferenceData] = useState([]);
    const [aioperation, setAiOperation] = useState(1.25);
    const [symbolDetails, setSymbolDetails] = useState([]);
    const [tradingviewsymbol, setTradingviewSymbol] = useState('ZC1!'); 
    const token = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');
    const [selectedNameVariable, setSelectedNameVariable] = useState(null);
    const [availableBalance, setAvailableBalance] = useState();
    const [bidAskData, setBidAskData] = useState();
    const [priceChange, setPriceChange] = useState();
    const [currentPrice, setCurrentPrice] = useState();
    const [highPrice, sethighPrice] = useState();
    const [lowPrice, setlowPrice] = useState();
    const [wasdeData, setWasdeData] = useState(null);
    const [latestWasdeData, setLatestWasdeData] = useState(null);

    const [latestConid, setLatestConid] = useState(null);
    const [olChange, setOlChange] = useState(null);
    const [aiPl, setAiPl] = useState(null);
    const [finalData, setFinalData] = useState([
        { symbol: 'AAPL', full_name: 'AAPL', exchange: 'XNAS', type: 'stocks'}
    ])
    const [watchListLoading, setWatchListLoading] = useState(true);
    const [bidLoading, setBidLoading] = useState(true);
    const [symbolDetailsLoading, setSymbolDetailsLoading] = useState(true);
    const [recentTransLoading, setRecentTransLoading] = useState(true);
    const [allocationPrefLoading, setAllocationPrefLoading] = useState(true);
    const [subdomain, setSubDomain] = useState('');
    const [newsData, setNewsData] = useState('');
    const [newsDataLoading, setNewsDataLoading] = useState(true);
    const [holdingsLoading, setholdingsLoading] = useState(true);
    const [accountLoading, setAccountLoading] = useState(true);
    const [invalidCryptocomKeys, setInvalidCryptocomKeys] = useState(null); // Store invalid keys for pre-filling
    const [cryptocomSymbolValid, setCryptocomSymbolValid] = useState(false); // Track if current symbol is valid for Crypto.com (default to false until validated)
    const [cryptocomSymbolValidationMessage, setCryptocomSymbolValidationMessage] = useState(''); // Validation message
    const [symbol_type, setSymbol_Type] = useState('stocks')
    const [etradeAuthData, setEtradeAuthData] = useState();
    const [etradeAllAccData, setEtradeAllAccData] = useState();
    const [sentimentScore, setSentimentScore] = useState();
    const [showEtradeAuth, setShowEtradeAuth] = useState(false);
    const [etradeIntegrationName, setEtradeIntegrationName] = useState('');
    const location = useLocation();

    const login = (accessToken, refreshToken, userId) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('userId', userId);
        setAuth({ accessToken, refreshToken, userId });
        // Refresh the page after successful login to ensure all components initialize correctly
        // This is especially important for Crypto.com to get the correct provider and symbol
        setTimeout(() => {
            window.location.reload();
        }, 100); // Small delay to ensure localStorage is saved
    };

    const logout = useCallback(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('subDomain');
        localStorage.removeItem('paidAt');
        localStorage.removeItem('planDuration');
        localStorage.removeItem('expiryAt');
        localStorage.removeItem('paymentType');
        localStorage.removeItem('userName');
        localStorage.clear();
        setAuth({ accessToken: null, refreshToken: null, userId: null });
        navigate('/');
    }, [setAuth, navigate]);

    useEffect(() => {
        const storedSymbol = localStorage.getItem('chartSymbol');
        if (storedSymbol) {
            setSelectedValue(storedSymbol);
            setSymbolData(storedSymbol);
        } else {

            localStorage.setItem('chartSymbol', 'AAPL');
        }
        
    }, []);

    // useEffect(() => {
    //     if (Array.isArray(wasdeData) && wasdeData.length > 0) {
    //         const latestItem = wasdeData[wasdeData.length - 1];
    //         setLatestWasdeData(latestItem); // Set latest item
            
    //         console.log(latestItem);
            
    //         if (latestItem && latestItem.conid) {
    //             fetchLiveMarketDataWithWasde(latestItem.conid); // Fetch live market data
    //             // getPriceChange(latestItem.conid,null,apiProvider)
    //             getOlChange(latestItem.conid);
    //         }
        // } else {
        //     setLatestWasdeData(null); // Reset if no data
        // }
    // }, [wasdeData]);

    // Helper function to get existing Crypto.com API keys (even if invalid) for pre-filling dialog
    const getExistingCryptocomKeys = useCallback(async () => {
        try {
            const token = localStorage.getItem('accessToken');
            const userId = localStorage.getItem('userId');
            
            if (!token || !userId) {
                return null;
            }
            
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}/integrations`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            
            if (!response.data || !Array.isArray(response.data)) {
                return null;
            }
            
            const cryptocomIntegration = response.data.find(integration => {
                if (!integration || !integration.name) return false;
                const name = integration.name.toLowerCase().trim();
                return name === 'crypto.com' || 
                       name === 'cryptocom' || 
                       name === 'crypto_com' ||
                       name === 'crypto-com';
            });
            
            if (!cryptocomIntegration) {
                return null;
            }
            
            const apiKey = cryptocomIntegration.api_key?.trim();
            const apiSecret = cryptocomIntegration.secret_key?.trim();
            
            // Return keys even if empty (for pre-filling)
            return {
                apiKey: apiKey || '',
                apiSecret: apiSecret || ''
            };
        } catch (error) {
            console.error("Error fetching existing Crypto.com keys:", error);
            return null;
        }
    }, []);

    // Helper function to get Crypto.com API keys from user integrations
    // Optional onKeysMissing callback will be called if keys are missing
    const getCryptocomApiKeys = useCallback(async (onKeysMissing = null) => {
        try {
            const token = localStorage.getItem('accessToken');
            const userId = localStorage.getItem('userId');
            
            if (!token || !userId) {
                console.log('Missing token or userId for getCryptocomApiKeys');
                return null;
            }
            
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}/integrations`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            
            if (!response.data || !Array.isArray(response.data)) {
                console.log('No integrations found or invalid response format');
                return null;
            }
            
            // Check for Crypto.com integration with various name formats
            const cryptocomIntegration = response.data.find(integration => {
                if (!integration || !integration.name) return false;
                const name = integration.name.toLowerCase().trim();
                return name === 'crypto.com' || 
                       name === 'cryptocom' || 
                       name === 'crypto_com' ||
                       name === 'crypto-com';
            });
            
            if (!cryptocomIntegration) {
                console.log('Crypto.com integration not found. Available integrations:', response.data.map(i => i.name));
                return null;
            }
            
            // Check if API keys exist and are not empty
            const apiKey = cryptocomIntegration.api_key?.trim();
            const apiSecret = cryptocomIntegration.secret_key?.trim();
            
            // Return null if keys are missing or empty
            if (!apiKey || !apiSecret || apiKey === '' || apiSecret === '') {
                console.log('Crypto.com integration found but API keys are missing or empty');
                
                // Call callback if provided - simple logic: just call it
                if (onKeysMissing && typeof onKeysMissing === 'function') {
                    console.log('Calling onKeysMissing callback to open dialog');
                    onKeysMissing();
                }
                
                return null;
            }
            
            console.log('Crypto.com API keys found successfully');
            return {
                apiKey: apiKey,
                apiSecret: apiSecret
            };
        } catch (error) {
            console.error("Error fetching Crypto.com API keys:", error);
            return null;
        }
    }, []);

    // Function to fetch user data
    const fetchUserData = useCallback(async (force = false) => {
        if (userData && !force) return userData; // Use existing data if already fetched
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${auth.userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                },
            });
            setUserData(response.data);
            setSubDomain(response.data.subdomain)
            setThirdParyAccount(response.data?.integrations?.current_integration);
            if (response.data.ai_settings && response.data.ai_settings.ai_operation) {
                setAiOperation(response.data.ai_settings.ai_operation);  // Set ai_operation from userData
            }
            return response.data;
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.status === 401) {
                alert('Your session has expired. Please log in again.');
                logout();
            }// Handle token expiration
        }
    }, [auth.accessToken, auth.userId, logout, userData]);

    const updateUserData = async (key, value) => {
        try {
            const token = localStorage.getItem('accessToken'); // Get the token from localStorage
            const userId = localStorage.getItem('userId');
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/user/${userId}`, // API endpoint
                { [key]: value }, // Dynamically set the key-value pair
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
    
            console.log(`${key} updated successfully:`, response.data);
            return response.data; // Return response for further usage
        } catch (error) {
            console.error(`Error updating ${key}:`, error);
            throw error; // Propagate the error for handling
        }
    }

    const deleteUserAccount = async() => {
        const token = localStorage.getItem('accessToken');
        const userId = localStorage.getItem('userId');
        try{
            const response = await axios.delete(
                `${process.env.REACT_APP_API_URL}/user/${userId}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            console.log(response);
            
            if(response.status === 200){
                logout();
            }
        }
        catch(error){
            console.error(`Error deleting:`, error);
            return null;
        }
    }

    const account = useCallback(async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/accounts-api`)
                // console.log(response);
                return response.data;
            }
            catch(error){
                console.error("Error fetching user data:", error);
            }
        }
        
    }, [userData]);

    const initEmailChange = async (newemail) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/init-email-change`, 
                { email: newemail },
                { headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            return response.data; // Return the response data on success
        } catch (error) {
            console.error("Error initiating email change:", error); // Updated log message
            if (error.response?.status === 401) {
                alert('Your session has expired. Please log in again.');
                logout();
            }
            return null; // Return null or an error object for consistency
        }
    };

    const changeEmail = async (otp,newemail) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/change-email`, 
                { otp: otp, newEmail: newemail, userId: auth.userId },
                { headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            return response.data; // Return the response data on success
        } catch (error) {
            console.error("Error initiating email change:", error); // Updated log message
            if (error.response?.status === 401) {
                alert('Your session has expired. Please log in again.');
                logout();
            }
            return null; // Return null or an error object for consistency
        }
    };

    const getWatchLists = async (provider, accountId) => {
        setWatchListLoading(true);
        const domain = localStorage.getItem('subDomain')
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');
        
        if(domain){
            try {
                // const response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/getWatchLists`);
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/getWatchLists?provider=${provider}`);
                }
                else if(provider === 'etrade'){
                    let id = userData.id;
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/getWatchLists?provider=${provider}&accountId=${accountId}&uid=${id}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/getWatchLists?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                else if(provider === 'cryptocom'){
                    const cryptocomKeys = await getCryptocomApiKeys();
                    if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
                        throw new Error('Crypto.com API keys not found. Please add them in settings.');
                    }
                    let id = userData.id;
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/getWatchLists?provider=${provider}&uid=${id}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-Key': cryptocomKeys.apiKey,
                            'X-API-Secret': cryptocomKeys.apiSecret,
                        }
                    });
                }
                setWatchlistData(response.data);
            } catch (error) {
                console.error("Error fetching watchlist data:", error);
                if (error.response?.status === 401) {
                    if (provider === 'etrade') {
                        // Clear existing tokens and trigger etrade auth
                        localStorage.removeItem('xAccessToken');
                        localStorage.removeItem('xAccessTokenSecret');
                        setEtradeIntegrationName('E*Trade');
                        handleOpenEtradeAuth();
                    } else if (provider === 'coinbase') {
                        // Clear existing token and trigger coinbase auth
                        localStorage.removeItem('coinAccessToken');
                        setEtradeIntegrationName('Coinbase');
                        handleOpenEtradeAuth();
                    } else if (provider === 'cryptocom') {
                        // Crypto.com 401 - invalid keys, get existing keys for pre-filling
                        console.log('Crypto.com API returned 401 - keys are invalid');
                        const existingKeys = await getExistingCryptocomKeys();
                        if (existingKeys) {
                            setInvalidCryptocomKeys(existingKeys);
                        }
                    } else {
                        setOpenSettings(true); // Open settings for other providers
                    }
                } else {
                    setOpenSettings(true); // Open settings for non-401 errors
                }
            } finally {
                setWatchListLoading(false); // Ensure loading state is updated
            }
        }
    };
    

    const getOrderData = async (provider, accountId) => {
        const domain = localStorage.getItem('subDomain')
        
        // setRecentTransLoading(true);
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        // Guard: require provider and domain
        if (!provider || !domain) {
            setRecentTransactionsData([]);
            setRecentTransLoading(false);
            return;
        }

        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/orders?provider=${provider}`);
                }
                else if(provider === 'robinhood'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/orders?provider=${provider}`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/orders?provider=${provider}&accountId=${accountId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/orders?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                else if(provider === 'cryptocom'){
                    const cryptocomKeys = await getCryptocomApiKeys();
                    if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
                        throw new Error('Crypto.com API keys not found. Please add them in settings.');
                    }
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/orders?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-Key': cryptocomKeys.apiKey,
                            'X-API-Secret': cryptocomKeys.apiSecret,
                        }
                    });
                }
                // Guard against undefined response shape
                const orders = response?.data?.orders ?? [];
                setRecentTransactionsData(orders);
                // return response.orders;
                if(response && response.status === 200){
                    setRecentTransLoading(false);
                }
            }
            catch(error){
                console.error("Error fetching user data:", error);
                if (error.response?.status === 401) {
                    if (provider === 'etrade') {
                        // Clear existing tokens and trigger etrade auth
                        localStorage.removeItem('xAccessToken');
                        localStorage.removeItem('xAccessTokenSecret');
                        setEtradeIntegrationName('E*Trade');
                        handleOpenEtradeAuth();
                    } else if (provider === 'coinbase') {
                        // Clear existing token and trigger coinbase auth
                        localStorage.removeItem('coinAccessToken');
                        setEtradeIntegrationName('Coinbase');
                        handleOpenEtradeAuth();
                    } else if (provider === 'cryptocom') {
                        // Crypto.com 401 - invalid keys, get existing keys for pre-filling
                        console.log('Crypto.com API returned 401 - keys are invalid');
                        const existingKeys = await getExistingCryptocomKeys();
                        if (existingKeys) {
                            setInvalidCryptocomKeys(existingKeys);
                        }
                    } else {
                        setOpenSettings(true); // Open settings for other providers
                    }
                } else {
                    setOpenSettings(true); // Open settings for non-401 errors
                }
                setRecentTransLoading(false);
            }
        }
    };

    const getRecentTransactions = async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/trades`)
                setTradeData(response.data);
                // console.log(response.data.orders);
                // return response.orders;
            }
            catch(error){
                console.error("Error fetching user data:", error);
                // setOpenSettings(true); 
            }
        }    
    };

    const createOrder = async (quantity, side, ordertype, cashqty, provider, symbol, baseCurencySym, curencySym, symType, qtyType, callput, strikePrice, timeInForce) => {
        const domain = localStorage.getItem('subDomain')
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        const accountID = userData?.integrations?.trade_account_id;
        if(domain){
            try {
                let response;
                let output;
                if(provider === 'IBKR'){
                    const orderData = {
                        orders: [
                            {
                                conid: parseInt(latestConid),
                                orderType: ordertype,
                                side: side,
                                tif: "GTC",
                                manualIndicator: false
                            }
                        ]
                    };
                    if (quantity) {
                        orderData.orders[0].quantity = quantity;
                    }
                    if (cashqty) {
                        orderData.orders[0].cashqty = cashqty;
                    }
                    // console.log(orderData);
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/createOrder`,
                        orderData
                    );

                    output = response.data;
                }
                else if(provider === 'robinhood'){
                    const orderData = {
                        side: side,
                        order_type: ordertype,
                        symbol: symbol,
                        order_config: {
                            asset_quantity: quantity
                        }
                    }
                    // console.log(orderData);
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/createOrder?provider=${provider}`,
                        orderData
                    );
                    output = response.data;
                }
                else if(provider === 'coinbase'){
                    const orderData = {
                        side: side,
                        symbol: symbol,
                        quantity: quantity,
                        base_currency: baseCurencySym,
                        currency_symbol: curencySym
                    }
                    // console.log(orderData);
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/createOrder?provider=${provider}`,
                        orderData,{
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                    output = response.data;
                }
                else if(provider === 'cryptocom'){
                    const cryptocomKeys = await getCryptocomApiKeys();
                    if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
                        throw new Error('Crypto.com API keys not found. Please add them in settings.');
                    }
                    
                    // Helper function to convert symbol format (e.g., X:BTCUSD -> BTC_USD)
                    const convertSymbolToCryptocomFormat = (symbol) => {
                        if (!symbol) return null;
                        
                        // Remove "X:" prefix if present
                        let cleanedSymbol = symbol.replace(/^X:/i, '').trim();
                        
                        // If already in correct format (contains underscore or dash), return as-is
                        if (cleanedSymbol.includes('_')) {
                            return cleanedSymbol;
                        }
                        if (cleanedSymbol.includes('-')) {
                            return cleanedSymbol;
                        }
                        
                        // Try to detect quote currency and split
                        // Order matters: try longer quotes first (USDT before USD)
                        const quoteCurrencies = ["USDT", "USDC", "USD", "CRO", "BTC", "ETH"];
                        for (const quote of quoteCurrencies) {
                            if (cleanedSymbol.toUpperCase().endsWith(quote.toUpperCase())) {
                                const base = cleanedSymbol.slice(0, -quote.length);
                                return `${base}_${quote}`;
                            }
                        }
                        
                        // If no match, assume last 3 chars are quote currency (default to USD)
                        if (cleanedSymbol.length > 3) {
                            return `${cleanedSymbol.slice(0, -3)}_${cleanedSymbol.slice(-3)}`;
                        }
                        
                        // Fallback: return as-is
                        return cleanedSymbol;
                    };
                    
                    // Determine base and currency symbols
                    let finalBaseCurrency = baseCurencySym;
                    let finalCurrencySymbol = curencySym;
                    
                    // If baseCurencySym or curencySym are missing, try to parse from symbol
                    if (!finalBaseCurrency || !finalCurrencySymbol) {
                        const convertedSymbol = convertSymbolToCryptocomFormat(symbol);
                        if (convertedSymbol && convertedSymbol.includes('_')) {
                            const parts = convertedSymbol.split('_');
                            if (parts.length >= 2) {
                                finalBaseCurrency = finalBaseCurrency || parts[0];
                                finalCurrencySymbol = finalCurrencySymbol || parts[1];
                            }
                        }
                    }
                    
                    // Crypto.com uses instrument_name format like BTC_USDT
                    const instrument_name = finalBaseCurrency && finalCurrencySymbol 
                        ? `${finalBaseCurrency}_${finalCurrencySymbol}` 
                        : convertSymbolToCryptocomFormat(symbol) || symbol;
                    
                    // Validate instrument before creating order
                    if (finalBaseCurrency && finalCurrencySymbol) {
                        const validation = await validateCryptocomInstrument(finalBaseCurrency, finalCurrencySymbol);
                        if (!validation.valid) {
                            throw new Error(validation.message || `Symbol ${instrument_name} is not available on Crypto.com Exchange. Please select a different trading pair.`);
                        }
                    }
                    
                    const orderType = ordertype === 'MKT' ? 'MARKET' : 'LIMIT';
                    const orderSide = side.toUpperCase();
                    
                    // Build base order data - backend will handle all calculations
                    const orderData = {
                        instrument_name: instrument_name,
                        side: orderSide,
                        type: orderType,
                        qtyType: qtyType || 'QUANTITY'  // QUANTITY or DOLLAR - backend uses this to determine calculation
                    };
                    
                    // Get the amount from user input (could be quantity or dollar amount)
                    // For DOLLAR: use cashqty (dollar amount), fallback to quantity
                    // For QUANTITY: use quantity
                    const amount = parseFloat(qtyType === 'DOLLAR' ? (cashqty || quantity) : quantity);
                    if (!amount || amount <= 0) {
                        throw new Error(`${qtyType === 'DOLLAR' ? 'Dollar amount' : 'Quantity'} is required`);
                        }
                    
                    // Pass amount to backend - backend will determine if it's quantity or dollar amount based on qtyType
                    // For DOLLAR: backend will calculate quantity/notional
                    // For QUANTITY: backend will use amount as quantity
                    orderData.amount = amount;
                    
                    // For LIMIT orders, pass the limit price
                    if (orderType === 'LIMIT') {
                        // Use strikePrice as limit price (it's the limit price field)
                        let limitPrice = null;
                        if (strikePrice && strikePrice !== '' && strikePrice !== 0 && !isNaN(parseFloat(strikePrice))) {
                            limitPrice = parseFloat(strikePrice);
                        }
                        
                        if (!limitPrice) {
                            throw new Error('Price is required for LIMIT orders');
                        }
                        orderData.price = limitPrice;
                    }
                    
                    // Add time_in_force for LIMIT orders
                    // Crypto.com API: GOOD_TILL_CANCEL, IMMEDIATE_OR_CANCEL, FILL_OR_KILL
                    if (orderType === 'LIMIT' && timeInForce) {
                        // Map frontend time_in_force values to Crypto.com API values
                        if (timeInForce === 'Day') {
                            // Day Order -> IMMEDIATE_OR_CANCEL (executes immediately, cancels unfilled portion)
                            orderData.time_in_force = 'IMMEDIATE_OR_CANCEL';
                        } else if (timeInForce === 'Good') {
                            // Good Till Cancelled -> GOOD_TILL_CANCEL
                            orderData.time_in_force = 'GOOD_TILL_CANCEL';
                        }
                    } else if (orderType === 'LIMIT') {
                        // Default to GOOD_TILL_CANCEL if not specified
                        orderData.time_in_force = 'GOOD_TILL_CANCEL';
                    }
                    
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/createOrder?provider=${provider}`,
                        orderData,{
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-Key': cryptocomKeys.apiKey,
                            'X-API-Secret': cryptocomKeys.apiSecret,
                        }
                    });
                    output = response.data;
                }
                else if(provider === 'etrade'){
                    const cliOrderId = `stock-${Math.random().toString(36).substr(2, 8)}`;
                    let mktType;
                    if(ordertype === 'MKT'){
                        mktType = 'MARKET';
                    }
                    else if(ordertype === 'LMT'){
                        mktType = 'LIMIT';
                    }
                    
                    // Determine orderTerm based on ordertype and timeInForce
                    let orderTerm = "GOOD_FOR_DAY"; // Default for MKT orders
                    if(ordertype === 'LMT' && timeInForce){
                        if(timeInForce === 'Day'){
                            orderTerm = "GOOD_FOR_DAY";
                        } else if(timeInForce === 'Good'){
                            orderTerm = "GOOD_UNTIL_CANCEL";
                        }
                    }
                    
                    if(symType === 'stocks'){
                        const orderData = {
                            orderType: "EQ", 
                            clientOrderId: cliOrderId,
                            Order: [
                                {
                                    priceType: mktType,
                                    orderTerm: orderTerm,
                                    marketSession: "REGULAR",
                                    ...(ordertype === 'LMT' || ordertype === 'TRAILLMT' ? { limitPrice: strikePrice } : {}),
                                    Instrument: [
                                        {
                                            Product: {
                                                symbol: symbol,
                                                securityType: "EQ"
                                            },
                                            orderAction: side,
                                            quantity: quantity,
                                            quantityType: qtyType,
                                        }
                                    ]
                                }
                            ]
                        }
                        // console.log(orderData);
                        response = await axios.post(
                            `${getApiBaseUrl(domain)}/custom-apis/createOrder?provider=${provider}&accountId=${accountID}`,
                            orderData,{
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Access-Token': `${xAccessToken}`,
                                    'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                                },
                            }
                        );
                        output = response.data;
                    }
                    else if(symType === 'indices'){
                        const orderData = {
                            orderType: "EQ", 
                            clientOrderId: cliOrderId,
                            Order: [
                                {
                                    priceType: mktType,
                                    orderTerm: "IMMEDIATE_OR_CANCEL",
                                    marketSession: "REGULAR",
                                    Instrument: [
                                        {
                                            Product: {
                                                symbol: symbol,
                                                securityType: "EQ"
                                            },
                                            orderAction: side,
                                            quantity: quantity,
                                            quantityType: qtyType,
                                        }
                                    ]
                                }
                            ]
                        }
                        // console.log(orderData);
                        response = await axios.post(
                            `${getApiBaseUrl(domain)}/custom-apis/createOrder?provider=${provider}&accountId=${accountID}`,
                            orderData,{
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Access-Token': `${xAccessToken}`,
                                    'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                                },
                            }
                        );
                        output = response.data;
                    }
                    else if(symType === 'otc'){
                        const orderData = {
                            orderType: "OPTN", 
                            clientOrderId: cliOrderId,
                            Order: [
                                {
                                    priceType: mktType,
                                    orderTerm: "GOOD_FOR_DAY",
                                    marketSession: "REGULAR",
                                    Instrument: [
                                        {
                                            Product: {
                                                symbol: symbol,
                                                securityType: "OPTN",
                                                callPut: callput,
                                                strikePrice: strikePrice,
                                            },
                                            orderAction: side,
                                            quantity: quantity,
                                            quantityType: qtyType,
                                        }
                                    ]
                                }
                            ]
                        }
                        console.log(orderData);
                        response = await axios.post(
                            `${getApiBaseUrl(domain)}/custom-apis/createOrder?provider=${provider}&accountId=${accountID}&is_expiry=true`,
                            orderData,{
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Access-Token': `${xAccessToken}`,
                                    'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                                },
                            }
                        );
                        output = response.data;
                    }
                }
                // console.log(response);
                // console.log(output);
                
                return output;
            } catch (error) {
                console.error("Error in createOrder:", error);
                if(provider === 'etrade'){
                    const details = JSON.parse(error.response?.data?.details || '{}');
                    showSweetAlert('Error!', details?.Error?.message || 'An error occurred', 'error');
                    return { error: details?.Error?.message || 'An error occurred' };
                }
                else if(provider === 'cryptocom'){
                    // Extract error message from Crypto.com API response
                    const errorData = error.response?.data;
                    if (errorData) {
                        // Map Crypto.com error codes to user-friendly messages
                        const errorCodeMessages = {
                            306: "Insufficient funds or assets available for this order. Please check your account balance.",
                            10001: "Invalid request parameters.",
                            10002: "Invalid API key or secret.",
                            10003: "Invalid signature.",
                            10004: "Rate limit exceeded. Please try again later.",
                            10005: "Permission denied. Please check your API key permissions.",
                            10006: "Internal server error. Please try again later.",
                        };
                        
                        // Prioritize error field (detailed message) over message field (code/constant)
                        // Backend returns detailed message in 'error' and code in 'message'
                        let errorMessage = 'An error occurred while placing the order';
                        
                        // If we have an error code, try to get a user-friendly message from mapping
                        if (errorData.code && errorCodeMessages[errorData.code]) {
                            errorMessage = errorCodeMessages[errorData.code];
                        } 
                        // If error field exists and contains detailed message, use it
                        else if (errorData.error && typeof errorData.error === 'string') {
                            errorMessage = errorData.error;
                        }
                        // If message field exists and is not just a code (contains spaces or is detailed), use it
                        else if (errorData.message && typeof errorData.message === 'string') {
                            // Check if message is just a code (all caps with underscores) or a detailed message
                            if (errorData.message.includes('_') && errorData.message === errorData.message.toUpperCase()) {
                                // It's a code like "INVALID_ORDERQTY" - convert to readable format
                                errorMessage = errorData.message
                                    .split('_')
                                    .map(word => word.charAt(0) + word.slice(1).toLowerCase())
                                    .join(' ');
                            } else if (errorData.message.includes(' ') || errorData.message.length > 20) {
                                // It's a detailed message (contains spaces or is long), use it
                                errorMessage = errorData.message;
                            } else {
                                // It's a short code, try to use error field if available, otherwise format the code
                                errorMessage = errorData.error || errorData.message
                                    .split('_')
                                    .map(word => word.charAt(0) + word.slice(1).toLowerCase())
                                    .join(' ');
                            }
                        }
                        
                        // Return error object - let the caller handle displaying the message
                        return { error: errorMessage, code: errorData.code };
                    }
                    // Fallback if no structured error data
                    return { error: error.message || 'An error occurred while placing the order' };
                }
                // For other providers, throw the error so it can be caught by the caller
                throw error;
                
            }
        }
    };
    
    // Helper function to validate Crypto.com instrument
    const validateCryptocomInstrument = useCallback(async (baseCurrency, currencySymbol) => {
        try {
            const domain = localStorage.getItem('subDomain');
            if (!domain) return { valid: false, message: 'Domain not found' };
            
            const instrument_name = `${baseCurrency}_${currencySymbol}`;
            const response = await axios.get(
                `${getApiBaseUrl(domain)}/custom-apis/validateCryptocomInstrument`,
                {
                    params: {
                        instrument_name: instrument_name,
                        provider: 'cryptocom'
                    }
                }
            );
            
            return response.data;
        } catch (error) {
            console.error("Error validating Crypto.com instrument:", error);
            return {
                valid: false,
                message: error.response?.data?.message || 'Error validating instrument'
            };
        }
    }, []);

    // Validate symbol for Crypto.com when symbol or provider changes
    // This runs on initial load, refresh, and when symbols change
    useEffect(() => {
        const validateSymbol = async () => {
            // Only validate for Crypto.com provider
            if (thirdParyAccount !== 'cryptocom') {
                setCryptocomSymbolValid(true);
                setCryptocomSymbolValidationMessage('');
                return;
            }

            // Try to get currency symbols from multiple sources
            let baseCurrency = baseCurencySymbol;
            let currencySymbol = curencySymbol;

            // If not set yet, try to get from finalData based on current symbolData
            if ((!baseCurrency || !currencySymbol) && symbolData && finalData && Array.isArray(finalData)) {
                const selectedSymbol = finalData.find((item) => item.symbol === symbolData);
                if (selectedSymbol) {
                    baseCurrency = baseCurrency || selectedSymbol?.base_currency_symbol || '';
                    currencySymbol = currencySymbol || selectedSymbol?.currency_symbol || '';
                }
            }

            // If still not set, try to parse from symbolData (e.g., "X:ABTUSD" -> "ABT" and "USD")
            if ((!baseCurrency || !currencySymbol) && symbolData) {
                // Remove "X:" prefix if present
                let symbol = symbolData.replace(/^X:/i, '').trim();
                
                // Special case: Set defaults for X:BTCUSD
                if (symbol === 'BTCUSD' && !baseCurrency && !currencySymbol) {
                    baseCurrency = 'BTC';
                    currencySymbol = 'USD';
                    // Set the state values
                    setBaseCurencySymbol('BTC');
                    setCurencySymbol('USD');
                } else {
                // Try to extract base and quote currency
                // Common patterns: ABTUSD, BTC_USDT, BTC-USDT
                if (symbol.includes('_')) {
                    const parts = symbol.split('_');
                    if (parts.length >= 2) {
                        baseCurrency = baseCurrency || parts[0];
                        currencySymbol = currencySymbol || parts[1];
                    }
                } else if (symbol.includes('-')) {
                    const parts = symbol.split('-');
                    if (parts.length >= 2) {
                        baseCurrency = baseCurrency || parts[0];
                        currencySymbol = currencySymbol || parts[1];
                    }
                } else {
                    // Try to detect quote currency (usually 3-4 chars at the end)
                    // Common quote currencies: USD, USDT, CRO, BTC, ETH
                    const commonQuotes = ['USDT', 'USD', 'CRO', 'BTC', 'ETH', 'USDC'];
                    for (const quote of commonQuotes) {
                        if (symbol.endsWith(quote) && symbol.length > quote.length) {
                            baseCurrency = baseCurrency || symbol.slice(0, -quote.length);
                            currencySymbol = currencySymbol || quote;
                            break;
                            }
                        }
                    }
                }
            }

            // If still not set, disable buttons
            if (!baseCurrency || !currencySymbol) {
                setCryptocomSymbolValid(false);
                setCryptocomSymbolValidationMessage('Symbol information is loading...');
                return;
            }

            try {
                console.log(`[Crypto.com Validation] Validating ${baseCurrency}_${currencySymbol}`);
                const validation = await validateCryptocomInstrument(baseCurrency, currencySymbol);
                console.log(`[Crypto.com Validation] Result:`, validation);
                setCryptocomSymbolValid(validation.valid);
                setCryptocomSymbolValidationMessage(
                    validation.valid 
                        ? '' 
                        : validation.message || `Symbol ${baseCurrency}_${currencySymbol} is not available on Crypto.com Exchange`
                );
            } catch (error) {
                console.error("Error validating symbol:", error);
                // On error, disable buttons to be safe
                setCryptocomSymbolValid(false);
                setCryptocomSymbolValidationMessage('Error validating symbol. Please try again.');
            }
        };

        // Validate when provider is known (from userData or thirdParyAccount)
        // This ensures it runs on initial load and refresh
        if (thirdParyAccount) {
            validateSymbol();
        } else if (userData?.integrations?.current_integration === 'cryptocom') {
            // Also check userData in case thirdParyAccount hasn't been set yet
            validateSymbol();
        }
    }, [baseCurencySymbol, curencySymbol, thirdParyAccount, userData, symbolData, finalData, validateCryptocomInstrument]);

    const addWatchlist = async (provider,baseCurencySym, curencySym, id, name, rows) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                // Validate instrument for Crypto.com before adding to watchlist
                if (provider === 'cryptocom' && baseCurencySym && curencySym) {
                    const validation = await validateCryptocomInstrument(baseCurencySym, curencySym);
                    if (!validation.valid) {
                        throw new Error(validation.message || `Symbol ${baseCurencySym}_${curencySym} is not available on Crypto.com Exchange`);
                    }
                }
                
                let response;
                if(provider === 'IBKR'){
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/addWatchlist?provider=${provider}`, 
                        { id: id, name: name, rows: rows }
                    );
                } 
                else if(provider === 'etrade'){
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/addWatchlist?provider=${provider}`, 
                        { base_currency:baseCurencySym, currency_symbol:curencySym, id: id, name: name, }
                    );
                }
                else if(provider === 'coinbase'){
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/addWatchlist?provider=${provider}`, 
                        { base_currency:baseCurencySym, currency_symbol:curencySym, id: id, name: name, }
                    );
                }
                else if(provider === 'cryptocom'){
                    // Watchlist operations don't require API keys - they just store in database
                    response = await axios.post(
                        `${getApiBaseUrl(domain)}/custom-apis/addWatchlist?provider=${provider}`, 
                        { base_currency:baseCurencySym, currency_symbol:curencySym, id: id, name: name, }
                    );
                }
                return response.data;
            } catch (error) {
                console.error("Error for addWatchlist:", error);
                throw error; // Re-throw so caller can handle the error
            }
        }
    };

    const deleteWatchlist = async (provider, id) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response = await axios.delete(
                    `${getApiBaseUrl(domain)}/custom-apis/deleteWatchlist?provider=${provider}&id=${id}`, 
                );
                // let response;
                // if(provider === 'IBKR'){
                //     response = await axios.delete(
                //         `${getApiBaseUrl(domain)}/custom-apis/deleteWatchlist?provider=${provider}&id=${id}`, 
                //     );
                // }
                await getWatchLists(thirdParyAccount, userData?.integrations?.trade_account_id);
                return response.data;
            } catch (error) {
                console.error("Error for addWatchlist:", error);
                
            }
        }
    };

    const aiSettings = async(integrations) => {
        try{
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/user/${userId}`, // Replace with your actual API endpoint
                { integrations },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            if (response.status === 200) {
                await fetchUserData(true);
            }
        }catch (error) {
            console.error("Error for addWatchlist:", error);
        }
    };

    const getSymbolTradeDate = useCallback(async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/getSymbolDetails`, {
                    params: {
                        symbol: selectedNameVariable,
                        secType: "FUT",
                    },
                });
                setSymbolTradeDate(response.data);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        }
    }, [selectedNameVariable]);

    useEffect(() => {
        if (selectedNameVariable) {
            getSymbolTradeDate();
        }
    }, [selectedNameVariable, getSymbolTradeDate]);

    const fetchSymbolDetails = async (symbol) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response = await axios.get(
                    `${getApiBaseUrl(domain)}/custom-apis/getSymbolDetails`,
                    {
                        params: {
                            symbol: symbol,
                            secType: "FUT",
                        },
                    }
                );
                return response.data; // Return the API response
            } catch (error) {
                console.error("Error fetching symbol details:", error);
                throw error; // Optionally rethrow the error to handle it in the caller function
            }
        }
    };

    const accountsSummary = async (provider, accountId, instType) => {
        setAccountLoading(true);
        const domain = localStorage.getItem('subDomain')
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/accountSummary`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/accountSummary?provider=${provider}&accountId=${accountId}&instType=${instType}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/accountSummary?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                else if(provider === 'cryptocom'){
                    const cryptocomKeys = await getCryptocomApiKeys();
                    if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
                        throw new Error('Crypto.com API keys not found. Please add them in settings.');
                    }
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/accountSummary?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-Key': cryptocomKeys.apiKey,
                            'X-API-Secret': cryptocomKeys.apiSecret,
                        }
                    });
                }
                setaccountInfoData(response.data);
                if(response.status === 200){
                    setAccountLoading(false);
                }
                // console.log(response.data);
                // return response.orders;
            }
            catch(error){
                console.error("Error fetching user data:", error);
                setAccountLoading(false);
                
                // Check for 401 error with Crypto.com (invalid keys)
                if (error.response?.status === 401 && provider === 'cryptocom') {
                    console.log('Crypto.com API returned 401 - keys are invalid');
                    const existingKeys = await getExistingCryptocomKeys();
                    if (existingKeys) {
                        setInvalidCryptocomKeys(existingKeys);
                    }
                }
                
                return null;
                // setOpenSettings(true); 
            }
        }
    };

    const holdingsData = async (provider, accountId) => {
        const domain = localStorage.getItem('subDomain')
        setholdingsLoading(true);
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/holdings-new`);
                }
                else if(provider === 'robinhood'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/holdings-new?provider=${provider}`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/holdings-new?provider=${provider}&accountId=${accountId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/holdings-new?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                else if(provider === 'cryptocom'){
                    const cryptocomKeys = await getCryptocomApiKeys();
                    if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
                        throw new Error('Crypto.com API keys not found. Please add them in settings.');
                    }
                    response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/holdings-new?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-Key': cryptocomKeys.apiKey,
                            'X-API-Secret': cryptocomKeys.apiSecret,
                        }
                    });
                }
                setYourHoldingData(response.data.holdings);
                // console.log(response.data);
                // return response.orders;
                if(response.status === 200){
                    setholdingsLoading(false);
                } 
            }
            catch(error){
                console.error("Error fetching user data:", error);
                setholdingsLoading(false);
                
                // Check for 401 error with Crypto.com (invalid keys)
                if (error.response?.status === 401 && provider === 'cryptocom') {
                    console.log('Crypto.com API returned 401 - keys are invalid');
                    const existingKeys = await getExistingCryptocomKeys();
                    if (existingKeys) {
                        setInvalidCryptocomKeys(existingKeys);
                    }
                }
                
                return null;
            }
        }
    };

    const preformanceData = useCallback(async (provider, accountId, new_interval, startDate, endDate) => {
        const domain = localStorage.getItem('subDomain')
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');
        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.post(`${getApiBaseUrl(domain)}/custom-apis/account-performance-categorized?provider=${provider}`,
                        {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate
                        });
                }
                else if(provider === 'etrade'){
                    response =  await axios.post(`${getApiBaseUrl(domain)}/custom-apis/account-performance-categorized2?provider=${provider}&accountId=${accountId}`,
                        {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate,
                            provider: provider
                          },{
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Access-Token': `${xAccessToken}`,
                                'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                            },
                        }
                    );
                }
                else if(provider === 'coinbase'){
                    response =  await axios.post(`${getApiBaseUrl(domain)}/custom-apis/account-performance-categorized2?provider=${provider}`,
                        {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate,
                            provider: provider
                          },{
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${coinAccessToken}`,
                            }
                        }
                    );
                }
                else if(provider === 'cryptocom'){
                    const cryptocomKeys = await getCryptocomApiKeys();
                    if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
                        throw new Error('Crypto.com API keys not found. Please add them in settings.');
                    }
                    response =  await axios.post(`${getApiBaseUrl(domain)}/custom-apis/account-performance-categorized2?provider=${provider}`,
                        {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate,
                            provider: provider
                          },{
                            headers: {
                                'Content-Type': 'application/json',
                                'X-API-Key': cryptocomKeys.apiKey,
                                'X-API-Secret': cryptocomKeys.apiSecret,
                            }
                        }
                    );
                }
                
                setPerfomanceChartData(response.data)
            }
            catch(error){
                console.error("Error fetching user data:", error);
            }
        }
    }, []);

    // Set default baseCurencySymbol and curencySymbol for Crypto.com when provider is detected
    useEffect(() => {
        if (thirdParyAccount === 'cryptocom') {
            const currentSymbol = symbolData || selectedValue || localStorage.getItem('chartSymbol');
            if (currentSymbol === 'X:BTCUSD' && (!baseCurencySymbol || !curencySymbol)) {
                setBaseCurencySymbol('BTC');
                setCurencySymbol('USD');
            }
        }
    }, [thirdParyAccount, symbolData, selectedValue, baseCurencySymbol, curencySymbol]);

    useEffect(() => {
        if(userData){
            holdingsData(thirdParyAccount, userData?.integrations?.trade_account_id);
            getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
            getWatchLists(thirdParyAccount, userData?.integrations?.trade_account_id);
            preformanceData(thirdParyAccount, userData?.integrations?.trade_account_id, '1D');
            accountsSummary(thirdParyAccount, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
            const interval = setInterval(() => {
                getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
            }, 10000);

            const summaryIntervalId = setInterval(() => {
                accountsSummary(thirdParyAccount, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
            }, 30000);
            // cleanup on unmount or dependency change
            return () => {
                clearInterval(interval);
                clearInterval(summaryIntervalId);
            };
        }
    },[thirdParyAccount, userData]);

    const allocations = useCallback(async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/allocations`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                },
            });

            setPreferenceData(response.data);

            if (response.status === 200) {
                setAllocationPrefLoading(false);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            setAllocationPrefLoading(false);
            return null;
        }
    }, [auth.accessToken]);

    const editAllocations = async (name, date, position, amount, id) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/allocations/${id}`, 
                {name: name, date:date, position:position, amount:amount},
                {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            
            if (response.status === 200) {
                // Call the get API to fetch the updated allocations
                await allocations();
            }
            return response;
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.status === 401) {
                alert('Your session has expired. Please log in again.');
                logout();
            }
            return null;
        }
    };

    const addAllocations = async (name, date, position, amount) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/allocations`, 
                {name: name, date:date, position:position, amount:amount},
                {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            if (response.status === 200 || response.status === 201) {
                // Call the get API to fetch the updated allocations
                await allocations(); // Assuming you have a function to get allocations
            }

            return response;
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.status === 401) {
                alert('Your session has expired. Please log in again.');
                logout();
            }
            return null;
        }
    };

    const deleteAllocations = async (id) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/allocations/${id}`, 
                {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            if (response.status === 200 || response.status === 201) {
                // Call the get API to fetch the updated allocations
                await allocations(); // Assuming you have a function to get allocations
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.status === 401) {
                alert('Your session has expired. Please log in again.');
                logout();
            }
            return null;
        }
    };

    // const trading_historical_data = async (symbol, from, to, schema) => {
    //     if(userData){
    //         try {
    //             const response =  await axios.get(`https://${subdomain}.nodoji.com/custom-apis/get-historical-data`,
    //                 {params: {
    //                     start_time_str : from,
    //                     end_time_str : to,
    //                     schema : schema,
    //                     symbol : symbol
    //                 }
    //             });
    //             return response.data?.historical_data;
    //         }
    //         catch(error){
    //             console.error("Error fetching trading_historical_data data:", error);
    //         }
    //     }
    // };

    const trading_live_data = async (symbol, provider) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
            const response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-live-data`, {
                params: {
                schema: 'ohlcv-1s',
                symbol: symbol,
                provider: provider

                },
            });
            if(response.status === 200){
                setSymbolDetailsLoading(false);
            }
            if (response.data && response.data && response.data.live_data.length > 0) {
                if(provider == 'polygon' || provider == 'cryptocom') {
                    setSymbolDetails(response.data.live_data)
                }
                return { data: response.data.live_data };
                
            } else {
                return null;
            }
            } catch (error) {
            console.error("Error fetching live data:", error);
            setSymbolDetailsLoading(false);
            return null;
            }
        }
    };


    const getWasde_data = useCallback(
        async (year = new Date().getFullYear(), cropType = 'corn') => {
          const params = new URLSearchParams();
          if (year) params.append('year', year);
          if (cropType) params.append('cropType', cropType);
    
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL}/wasde-reports?${params.toString()}`,
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${auth.accessToken}`,
                }
              }
            );
            console.log(response.data);
            
            setWasdeData(response.data); // Update latestWasdeData in AuthContext
            return response.data;
          } catch (error) {
            console.error('Error fetching WASDE data:', error.message);
            return null;
          }
        },
        [auth.accessToken] // Dependencies: stabilize function based on accessToken
    );
    

    const supportEmail = async (title, description) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/support-email`, 
                { 
                    title: title,
                    description: description
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${auth.accessToken}`,
                    },
                }
            );
            return response.data; // Return the response data on success
        } catch (error) {
            console.error("Error supportEmail:", error); // Updated log message
            return null; // Return null or an error object for consistency
        }
    };
      
    const bid_ask_data = async (symbol, provider) => {
        setBidLoading(true);
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                // Determine the correct provider for the API call
                // If Crypto.com is selected, use 'cryptocom' as provider even if apiProvider is 'polygon'
                const currentProvider = thirdParyAccount || userData?.integrations?.current_integration;
                let apiProviderParam = provider;
                
                if (currentProvider === 'cryptocom') {
                    apiProviderParam = 'cryptocom';
                } else if (currentProvider === 'IBKR') {
                    apiProviderParam = 'ibkr';
                } else if (provider) {
                    // Use the provided provider (polygon for other cases)
                    apiProviderParam = provider;
                }
                
                const response =  await axios.get(`${getApiBaseUrl(domain)}/custom-apis/latest_bid_ask`,
                    {params: {
                        symbol : symbol,
                        dataset : 'GLBX.MDP3',
                        provider: apiProviderParam
                    }
                });
                setBidAskData(response.data?.asks_and_bids)
                if(response.status === 200){
                    setBidLoading(false);
                }
            }
            catch(error){
                console.error("Error fetching asks_and_bids data:", error);
                setBidLoading(false);
            }
        }
    };

    const fetchLiveMarketDataWithWasde = async (conid) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
        // console.log('Fetched Conid:', conid);
            try{
                const response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-live-market-data?conids_str=${conid}`);
                // console.log("DATA FROM FETCHING CONID:", response.data);
                setSelectedValueAnalysis(response.data);
                return response.data;
            }
            catch(error){
                console.error("Error fetching getLiveMarketData", error);
            }
        }
    }

    const getLiveMarketData = async (symbol) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                const response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-live-market-data?conids_str=${symbol}`);
                setSymbolDetails(response.data);
                
                return response.data;
            }
            catch(error){
                console.error("Error fetching getLiveMarketData", error);
                // setSymbolDetailsLoading(false); 
            }
        }
    }

    const getHistoricalMarketData = async (schema,period, apiProvider, symbol, conid, time) => {
        const domain = localStorage.getItem('subDomain')

        if(domain){
            try {
                let params = {

                }
                if(apiProvider == 'IBKR') {
                    params = {
                        conid: conid,
                        bar: schema,
                        period: period,
                    };
                    if (time) {
                        params.startTime = time;
                    }
                } else {

                    let bar, adjustedPeriod, startTime;
                    if (schema.endsWith('d')) {
                        bar = parseInt(schema.replace('d', ''), 10); // Extract the numeric part for days
                        adjustedPeriod = 'day';
                    } else if (schema.endsWith('w')) {
                        bar = parseInt(schema.replace('w', ''), 10); // Extract the numeric part for weeks
                        adjustedPeriod = 'week';
                    } else if (schema.endsWith('m')) {
                        bar = parseInt(schema.replace('m', ''), 10); // Extract the numeric part for months
                        adjustedPeriod = 'month';
                    } else if (schema.endsWith('h')) {
                        bar = parseInt(schema.replace('h', ''), 10); // Extract the numeric part for hours
                        adjustedPeriod = 'hour';
                    } else if (schema.endsWith('min')) {
                        bar = parseInt(schema.replace('min', ''), 10); // Extract the numeric part for minutes
                        adjustedPeriod = 'minute';
                    } else {
                        bar = schema; // Default to the provided schema
                        adjustedPeriod = 'custom'; // Default period
                    }

                    switch (period) {
                        case '1d':
                            startTime = new Date(time);
                            startTime.setDate(startTime.getDate() - 1);

                            // Check if it's Saturday (6) or Sunday (0) and adjust to Friday
                            if (startTime.getDay() === 6) { // Saturday
                                startTime.setDate(startTime.getDate() - 1); // Move to Friday
                            } else if (startTime.getDay() === 0) { // Sunday
                                startTime.setDate(startTime.getDate() - 2); // Move to Friday
                            }
                            break;
                        case '3m':
                            startTime = new Date(time);
                            startTime.setMonth(startTime.getMonth() - 3);
                            break;
                        case '1y':
                            startTime = new Date(time);
                            startTime.setFullYear(startTime.getFullYear() - 1);
                            break;
                        case '5y':
                            startTime = new Date(time);
                            startTime.setFullYear(startTime.getFullYear() - 5);
                            break;
                        case '6y':
                            startTime = new Date(time);
                            startTime.setFullYear(startTime.getFullYear() - 6);
                            break;
                        default:
                            startTime = new Date(time);
                    }
            
                    // Format startTime
                    startTime = startTime.toISOString().split("T")[0];
                    
                    params = {
                        provider: "polygon",
                        bar: bar,
                        period: adjustedPeriod,
                        startTime: startTime,
                        endTime: time,
                        symbol: symbol
                    };
                    
                }
                
                const response = await axios.get(
                    `${getApiBaseUrl(domain)}/custom-apis/get-historical-market-data-new`,
                    { params }
                );
                
                return response.data;
            } catch (error) {
                console.error("Error fetching historical-market-data:", error);
            }
        }
    }

    const getPriceChange = async (conid,symbol, provider) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                let response;
                if(provider!= 'IBKR'){
                    response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-price-changes?symbol=${symbol}&provider=${provider}`);
                }
                else{
                    response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-price-changes?conid=${conid}`);
                }
                setPriceChange(response.data.price_changes);
            }
            catch(e){
                console.log("Error getPriceChange :", e);
            }
        }
    }

    const getOlChange = async (conid) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                const response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-last-ol-value?conid=${conid}`);
                setOlChange(response.data?.ol_value);
            }
            catch(e){
                console.log("Error getPriceChange :", e);
            }
        }
    }

    const getAiPl = async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                const response = await axios.get(`${getApiBaseUrl(domain)}/custom-apis/get-ai-pl`);
                setAiPl(response.data);
            }
            catch(e){
                console.log("Error getPriceChange :", e);
            }
        }
    }

    const getCropCondition = async (year = 2024, cropcondition = 'Corn Condition', state = '18 Sts') => {
        try {
            const url = `https://newwebapi.nodojicommodities.com/usda-condition-reports?year=${year}&cropType=${cropcondition}&state=${state}`;
            
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${auth.accessToken}`,
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching crop condition data:', error.message);
            return null;
        }
    };

    const getCropProgress = async (year = 2024, cropstage = 'Corn Planted', state = '18 States') => {
        try {
            const url = `https://newwebapi.nodojicommodities.com/usda-progress-reports?year=${year}&cropStage=${cropstage}&state=${state}`

            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${auth.accessToken}`,
                }
                
            });
            return response.data;
        }
        catch (error) {
            console.error('Error fetching crop progress data:', error.message);
            return null;
        }
    }
    
    const getAiPnlResults = async(interval) => {
        try{
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pnl-results?date_range=${interval}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${auth.accessToken}`,
                    }
                }
            );
            return response.data;
        }catch(error){
            console.error('Error fetching AiPnl data:', error.message);
            return null;
        }
    }

    const getNews = useCallback(
        async (symbol) => {
          setNewsDataLoading(true);

          let baseSymbol = symbol;
            if (userData && userData.integrations && userData.integrations.current_integration && userData.integrations.current_integration === 'IBKR') {
                baseSymbol = symbol.split("-")[0];
            } else if (userData && userData.integrations && userData.integrations.current_integration && userData.integrations.current_integration === 'cryptocom') {
                // For Crypto.com, transform symbols like X:BTCUSD => BTC, X:ABTUSD => ABT
                // Remove "X:" prefix if present
                let cleanedSymbol = symbol.replace(/^X:/i, '').trim();
                
                // Remove common quote currency suffixes (USD, USDT, USDC, CRO, BTC, ETH)
                // Order matters: try longer quotes first (USDT before USD)
                const quoteCurrencies = ["USDT", "USDC", "USD", "CRO", "BTC", "ETH"];
                for (const quote of quoteCurrencies) {
                    if (cleanedSymbol.toUpperCase().endsWith(quote.toUpperCase())) {
                        baseSymbol = cleanedSymbol.slice(0, -quote.length);
                        break;
                    }
                }
                
                // If no quote currency found, use the cleaned symbol as-is
                if (baseSymbol === symbol) {
                    baseSymbol = cleanedSymbol;
                }
            } else {
                baseSymbol = symbol
            }
            
          try {
            const response = await axios.get(
              `https://userapi.nodojicommodities.com/custom-apis/get-ticker-news?ticker=${baseSymbol}`
            );
      
            if (response.status === 200) {
              // Extract all sentiment values related to the specific symbol
              const filteredSentiments = response.data.results
                .flatMap((article) => article.insights) // Get all insights from articles
                .filter((insight) => insight.ticker === symbol) // Filter by the provided symbol
                .map((insight) => insight.sentiment_reasoning); // Extract only sentiment values
      
                if(filteredSentiments.length === 0){
                    setNewsData(response.data.results);
                    setNewsDataLoading(false);
                }
                else if (filteredSentiments.length > 0) {
                    const sentimentData = await axios.post(
                    `https://sentimentanalysis.nodoji.com/predict`,
                    {
                        texts: filteredSentiments, // Send filtered sentiments as an array
                    },
                    {
                        headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.accessToken}`,
                        },
                    }
                    );
        
                    if (sentimentData.status === 200) {
                        setNewsDataLoading(false);
                        setSentimentScore(sentimentData.data);
                        setNewsData(response.data.results);
                    }
                    else{
                        setNewsDataLoading(true);
                        setNewsData('');
                    }
                }
                
                if (response.data.results.length === 0) {
                    setNewsDataLoading(false);
                }
            }
          } catch (error) {
            console.error("Error fetching AiPnl data:", error.message);
            setNewsDataLoading(false);
            return null;
          }
        },
        [auth.accessToken] // Dependencies: ensure it updates when `auth.accessToken` changes
    );


    const createNewIntegrations = async(name, apikey, secretKey, extraKey) => {
        const token = localStorage.getItem('accessToken'); // Get the token from localStorage
        const userId = localStorage.getItem('userId');

        try{
            // Ensure all values are strings (convert undefined/null to empty string)
            const payload = {
                name: name || '',
                api_key: (apikey !== undefined && apikey !== null) ? String(apikey) : '',
                secret_key: (secretKey !== undefined && secretKey !== null) ? String(secretKey) : '',
                extra_key: (extraKey !== undefined && extraKey !== null) ? String(extraKey) : ''
            };
            
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/user/${userId}/integrations`, 
                payload,
                { headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }}
            );
            console.log(response);
            
            if (response.status === 200 || response.status === 201) {
                // Check if userData.integrations is empty or doesn't have current_integration
                if (!userData?.integrations || Object.keys(userData.integrations).length === 0 || !userData.integrations.current_integration) {
                    // Map integration name to current_integration value
                    let currentIntegration = '';
                    switch(name) {
                        case 'InteractiveBrokers':
                            currentIntegration = 'IBKR';
                            break;
                        case 'E*Trade':
                            currentIntegration = 'etrade';
                            break;
                        case 'Coinbase':
                            currentIntegration = 'coinbase';
                            break;
                        case 'Crypto.com':
                            currentIntegration = 'cryptocom';
                            break;
                        default:
                            currentIntegration = name.toLowerCase();
                    }
                    
                    // Call aiSettings to set current_integration (this already calls fetchUserData)
                    await aiSettings({ current_integration: currentIntegration });
                } else {
                    // If integrations already exist, just fetch updated user data
                    await fetchUserData(true);
                }
            }
            
            return response.data;
        }
        catch(error){
            console.error('Error creating new integrations:', error.message);
            return null;
        }
    }

    const eTradeAuth = async(provider) => {
        try{
            const response = await axios.get(`https://userapi.nodojicommodities.com/custom-apis/auth/login?provider=${provider}`);
            // console.log(response.data);
            return response.data;
        }
        catch(error){
            console.log('Failed to get authenticate:',error.message);
            return null;
        }
    }

    const etradeAuthCallback = async(provider, verifier, resourceOwnerKey, resourceOwnerSecret) => {
        try{
            const response = await axios.post(`https://userapi.nodojicommodities.com/custom-apis/auth/callback?provider=${provider}&oauth_verifier=${verifier}&resource_owner_key=${resourceOwnerKey}&resource_owner_secret=${resourceOwnerSecret}`);
            return response.data;
        }
        catch(error){
            console.log('failed etradeAuthCallback:',error.message);
            return null;
        }
    }

    const etradeAllAcc = async() => {
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');

        try{
            const response = await axios.get(`https://userapi.nodojicommodities.com/custom-apis/all-etrade-account`, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Access-Token': `${xAccessToken}`,
                    'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                },
            });
            setEtradeAllAccData(response.data);
            console.log(response.data);
        }
        catch(error){
            console.log('failed to get etradeAllAcc:',error.message);
            return null;
        }
    }

    useEffect(() => {
        // Get and format the current date
        const date = new Date();
        const formattedDate = date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        setCurrentDate(formattedDate);

        // Get and format the current time in 24-hour format based on user's timezone
        const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        setCurrentTime(formattedTime);

        if(location.pathname === '/Home/Portfolio'){
            getNews(symbolData);
        }
    }, [userData])

    return (
        <AuthContext.Provider value={{ subdomain, auth, login, logout, fetchUserData, userData,setUserData, updateUserData, initEmailChange, changeEmail, selectedValue, setSelectedValue, currentDate, currentTime, recentTransactionsData, accountInfoData, openSettings, handleOpenSettings, handleCloseSettings, setOpenSettings, watchlistData, yourHoldingData, aioperation, setAiOperation, account, createOrder, addWatchlist, deleteWatchlist, getWatchLists, aiSettings, preformanceData, tradeData, preferenceData, symbolDetails, editAllocations, addAllocations, settingParams, symbolTradeDate, setSelectedNameVariable, getSymbolTradeDate, fetchSymbolDetails, deleteAllocations, perfomanceChartData, trading_live_data, availableBalance, setAvailableBalance, supportEmail, latestWasdeData, getWasde_data, getCropCondition, getCropProgress, getLiveMarketData, getHistoricalMarketData, getPriceChange, priceChange, bid_ask_data, bidAskData, currentPrice, setCurrentPrice, selectedValueAnalysis, setSelectedValueAnalysis, tradingviewsymbol, setTradingviewSymbol ,setLatestConid, finalData, setFinalData, getOrderData, watchListLoading, bidLoading, symbolDetailsLoading, recentTransLoading, allocationPrefLoading, setAllocationPrefLoading, symbolData, setSymbolData, olChange, getOlChange, aiPl, highPrice, sethighPrice, lowPrice, setlowPrice, getAiPnlResults, apiProvider, setApiProvider, getNews, newsData, newsDataLoading, setThirdParyAccount, fetchLiveMarketDataWithWasde, setLatestWasdeData, symbol_type, setSymbol_Type, createNewIntegrations, holdingsLoading, holdingsData, thirdParyAccount, eTradeAuth, setEtradeAuthData, etradeAuthData, etradeAuthCallback, etradeAllAcc, etradeAllAccData, integrationsParams, accountsSummary, sentimentScore, baseCurencySymbol, setBaseCurencySymbol, curencySymbol, setCurencySymbol, setSymbolDetailsLoading, deleteUserAccount, showEtradeAuth, handleOpenEtradeAuth, handleCloseEtradeAuth, etradeIntegrationName, setEtradeIntegrationName, getCryptocomApiKeys, invalidCryptocomKeys, setInvalidCryptocomKeys, getExistingCryptocomKeys, validateCryptocomInstrument, cryptocomSymbolValid, cryptocomSymbolValidationMessage}}>
            {children}
        </AuthContext.Provider>
    );
};